export const hasUserChangedSinceStamp = (data = {}) =>
  data?.user_changed_since_stamp === true;

export const hasIdentityChangedSinceStamp = (data = {}) =>
  data?.identity_changed_since_stamp === true;

export const hasIdentityDowngradedSinceStamp = (data = {}) =>
  hasIdentityChangedSinceStamp(data) &&
  data?.verified_at_stamp_time === true &&
  data?.verified === false;

export const shouldShowUserAtStampTime = (data = {}) =>
  hasUserChangedSinceStamp(data);

export const shouldShowIdentityAtStampTime = (data = {}) =>
  hasUserChangedSinceStamp(data) || hasIdentityDowngradedSinceStamp(data);

export const getUserAtStampTime = (data = {}) =>
  data?.user_at_stamp_time || data?.user_id || "<<None>>";

export const getIdentityStatusLabel = (verified) =>
  verified === true ? "Verified" : "Unverified";

export const getIdentityAtStampTime = (data = {}) =>
  getIdentityStatusLabel(data?.verified_at_stamp_time);
